import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Models
export interface employee {
    id: number;
    name: string;
    serial_no: string;
   
    mobile: string;
    job: string;
    salary: number;
    workingStatus:"",
    working_status: 'Working' | 'Pending' | 'Suspended';
    salaries: {
        date: string;
        salary: number;
        additional_time: number;
        additional_value: number;
        absence_time: number;
        discount_value: number;
        net_salary: number;
    }[]
}
interface iEmployee {[key:number]:employee[]}
// Employees state
export interface employeesState {
    isLoaded: boolean, // First load
    isLoading: boolean, // On filtering laoder
    isFetching: boolean,
    hasMore: boolean,
    employees: iEmployee,
    page:number,
}

const initialEmployeesState: employeesState = {
    isLoaded: false,
    isLoading: false,
    isFetching: false,
    hasMore: true,
    employees: [],
    page:1
}

// Employees slice
export const employeesSlice = createSlice({
    name: 'employees',
    initialState: initialEmployeesState,
    reducers: {
        init: ( state, {payload}: PayloadAction<employee[]> ) => {
            state.employees[state.page] = payload
        },
        setIsLoaded: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoaded = payload
        },
        setIsLoading: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoading = payload
        },
        setIsFetching: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isFetching = payload
        },
        setHasMore: ( state, {payload}: PayloadAction<boolean> ) => {
            state.hasMore = payload
        },
        addEmployees: ( state, {payload}: PayloadAction<employee[]> ) => {
            state.employees[state.page] = state.employees[state.page]?
            [ ...state.employees[state.page], ...payload ]: [...payload]
        },
        updateEmployee: ( state, {payload}: PayloadAction<employee> ) => {
          
            let index = state.employees[state.page].findIndex( employee => employee.id === payload.id )
            if( index !== -1 )
            state.employees[state.page][index] = payload
        },
        deleteEmployees: ( state, {payload}: PayloadAction<number[]> ) => {
            payload.map(id => {
                let index = state.employees[state.page].findIndex( employee => employee.id === id )
                if( index != -1 )
                state.employees[state.page].splice( index, 1 )
            })
        },
        reset: ( state ) => {
            state.employees = []
            state.hasMore = true
        },
        setPage:(state,{payload}:PayloadAction<number>)=>{
           state.page=payload
       }

    }
})